import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Spinner } from '@instructure/ui-spinner';
import { View } from '@instructure/ui-view';
import { AddContentPopover, QuizInstructions, QuizTitle } from '@instructure/quiz-core';
import { QUIZ_ENTRY_REF, INSTRUCTIONS_SCROLL_KEY, TITLE_SCROLL_KEY } from '@instructure/quiz-common';
import t from '@instructure/quiz-i18n/es/format-message';
import QuizEntriesSection from '../QuizEntriesSection';
export var BuildContent = /*#__PURE__*/function (_Component) {
  function BuildContent() {
    var _this;
    _classCallCheck(this, BuildContent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, BuildContent, [].concat(args));
    _defineProperty(_this, "quizId", function () {
      return _this.props.quiz.id;
    });
    _defineProperty(_this, "quizEntryRef", function (quizEntryId) {
      return function (node) {
        _this["".concat(QUIZ_ENTRY_REF, "_").concat(quizEntryId)] = node;
      };
    });
    _defineProperty(_this, "quizEntryWrapperRef", function (quizEntryId) {
      return function (node) {
        _this["".concat(QUIZ_ENTRY_REF, "_").concat(quizEntryId)] = node;
      };
    });
    _defineProperty(_this, "renderAddContentPopover", function (isOver, position) {
      var _this$props = _this.props,
        quiz = _this$props.quiz,
        lockBlueprintContentEnabled = _this$props.lockBlueprintContentEnabled;
      var isQuizContentLocked = quiz.originalQuizLockedByBlueprint && lockBlueprintContentEnabled;
      var shouldRenderAddContentPopover = !(isOver || isQuizContentLocked);
      return shouldRenderAddContentPopover ? /*#__PURE__*/React.createElement(AddContentPopover, {
        quizId: _this.quizId(),
        position: position
      }) : null;
    });
    _defineProperty(_this, "storeStartQuizEntries", function (node) {
      _this.startQuizEntries = node;
    });
    _defineProperty(_this, "storeEndQuizEntries", function (node) {
      _this.endQuizEntries = node;
    });
    return _this;
  }
  _inherits(BuildContent, _Component);
  return _createClass(BuildContent, [{
    key: "render",
    value: function render() {
      return this.props.connectDropTarget(/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(QuizTitle, {
        onQuizUpdated: this.props.onQuizUpdated,
        quiz: this.props.quiz,
        workingQuiz: this.props.workingQuiz,
        scrollKey: TITLE_SCROLL_KEY
      }), /*#__PURE__*/React.createElement(QuizInstructions
      // to help with DnD above first quizEntry:
      , {
        ref: this.storeStartQuizEntries,
        quiz: this.props.quiz,
        scrollKey: INSTRUCTIONS_SCROLL_KEY
      }), this.renderAddContentPopover(this.props.isOver, 0), !this.props.quizEntriesLoaded ? /*#__PURE__*/React.createElement(View, {
        as: "div",
        padding: "large",
        textAlign: "center"
      }, /*#__PURE__*/React.createElement(Spinner, {
        renderTitle: t('Loading')
      })) : /*#__PURE__*/React.createElement(QuizEntriesSection, {
        isOver: this.props.isOver,
        quizId: this.props.quiz.id,
        isContentLockedByBlueprint: this.props.isContentLockedByBlueprint,
        quizEntries: this.props.quizEntries,
        renderAddContentPopover: this.renderAddContentPopover,
        setQuizEntryRef: this.quizEntryRef,
        setQuizEntryWrapperRef: this.quizEntryWrapperRef
      }), /*#__PURE__*/React.createElement("div", {
        ref: this.storeEndQuizEntries
      })));
    }
  }]);
}(Component);
_defineProperty(BuildContent, "propTypes", {
  connectDropTarget: PropTypes.func.isRequired,
  // injected by DnD
  isOver: PropTypes.bool,
  // injected by DnD
  lockBlueprintContentEnabled: PropTypes.bool.isRequired,
  onQuizUpdated: PropTypes.func,
  // passed in by consumer, optional
  quiz: ImmutablePropTypes.record.isRequired,
  quizEntries: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
  quizEntriesLoaded: PropTypes.bool.isRequired,
  workingQuiz: ImmutablePropTypes.record.isRequired,
  isContentLockedByBlueprint: PropTypes.bool.isRequired
});
_defineProperty(BuildContent, "defaultProps", {
  isOver: false,
  isContentLockedByBlueprint: false,
  lockBlueprintContentEnabled: false,
  onQuizUpdated: function onQuizUpdated() {}
});
export default BuildContent;